import { AnimatePresence, m } from 'framer-motion';
import { Col, Container, Row } from 'react-bootstrap';
import Lists from '../../../../Litho/Components/Lists/Lists';
import colors from '../../../../constants/colors';
import Buttons from '../../../../Litho/Components/Button/Buttons';
import {
	fadeIn,
	fadeInLeft,
	fadeInRight,
} from '../../../../Litho/Functions/GlobalAnimations';
import dayjs from 'dayjs';

const listData = [
	{
		icon: 'fa fa-circle-chevron-right !text-[4px] !text-tprimary',
		content: (
			<span className='text-tgray font-normal text-[14px]'>
				Simplify your logistic shipment
			</span>
		),
	},
	{
		icon: 'fa fa-circle-chevron-right !text-[4px] !text-tprimary',
		content: (
			<span className='text-tgray font-normal text-[14px]'>
				Supporting your end-to-end shipment
			</span>
		),
	},
	{
		icon: 'fa fa-circle-chevron-right !text-[4px] !text-tprimary',
		content: (
			<span className='text-tgray font-normal text-[14px]'>
				Straightforwardand efficient shipment
			</span>
		),
	},
];

const data = [
	{
		title: `4 Container, ${dayjs().subtract(1, 'day').format('DD MMM')}`,
		content: 'Departure fron San jose',
		icon: 'fa solid-icon-Ship text-3xl bg-red-100 text-[#bd3531] p-2 rounded',
	},
	{
		title: `3 Container, ${dayjs().subtract(7, 'day').format('DD MMM')}`,
		content: 'Transit at mexico city',
		icon: 'fa fa-clock-four text-3xl bg-[#fae4d4] text-[#eb7e2b] p-2 rounded',
	},
	{
		title: `2 Container, ${dayjs().subtract(12, 'day').format('DD MMM')}`,
		content: 'Arrived at St Sao Paulo',
		icon: 'fa solid-icon-Location-2 text-3xl bg-[#d4f5d4] text-[#28a745] p-2 rounded',
	},
];

const SupplyChainSection = () => {
	return (
		<AnimatePresence>
			<Container>
				<Row className='items-center justify-center'>
					<Col sm={12} md={7} lg={7}>
						<m.div
							className='md:mb-20 consulting-about notMobile:w-[70%]'
							{...{
								...fadeInRight,
								transition: { duration: 0.9 },
								viewport: { once: false },
							}}
						>
							<h5 className='text-ttertiary font-funnel font-semibold sm: mb-3'>
								Supply chain services for easy transport
							</h5>
							<span className='text-sm text-tgray'>
								We make end-to-end supply chain more easier and smoother for
								oyu. Turning your complexity shipment process into smoothest one
							</span>
							<div className='mt-[20px] md:mt-[45px] xs:mt-[25px]'>
								<Lists theme='list-style-02' data={listData} />
							</div>
							<div className='mt-[50px] md:mt-[25px] xs:mt-[20px] landscape:md:mt-[40px]'>
								<Buttons
									to='/services'
									className='mr-[35px] btn-flat btn-fancy rounded-full font-medium font-serif uppercase md:mb-[15px] xs:mb-0'
									themeColor={colors.tprimary}
									color='#fff'
									size='sm'
									title='Learn More'
								/>
							</div>
						</m.div>
					</Col>

					<Col sm={12} md={5} lg={5}>
						<m.div
							className={`flex justify-center items-center mb-28 sm:mb-10`}
							{...{
								...fadeInLeft,
								transition: { duration: 0.9 },
								viewport: { once: false },
							}}
						>
							<div className='flex flex-col items-center justify-center gap-8'>
								{data?.map((item, index) => (
									<m.section
										key={index}
										className={`bg-gray-100 bg-opacity-50 rounded-xl flex items-center justify-center gap-3 text-ttertiary pr-6 p-3 ${
											index % 2 === 0 ? 'mr-20' : ''
										}`}
										{...fadeIn}
									>
										<span className={item.icon} />
										<div className='flex flex-col gap-0 text-lg font-medium font-funnel'>
											<span className='text-[12px] text-tgray'>
												{item?.content}
											</span>
											{item?.title}
										</div>
									</m.section>
								))}
							</div>
						</m.div>
					</Col>
				</Row>
			</Container>
		</AnimatePresence>
	);
};

export default SupplyChainSection;
